import { useVersionCheck } from '../../hooks/useVersionCheck';

const AboutModal = ({ isOpen, onClose }) => {
  const { currentVersion, currentBuildNumber } = useVersionCheck();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
      <div 
        className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-[#022b73]">About PLSSS Agents</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
          >
            &times;
          </button>
        </div>

        <div className="space-y-3 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">Version:</span>
            <span className="font-medium">{currentVersion}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Build:</span>
            <span className="font-medium text-xs">{currentBuildNumber}</span>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="w-full bg-[#022b73] text-white px-4 py-2 rounded-lg font-medium hover:bg-[#022b73]/90 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
